module.exports = __webpack_public_path__ + "media/images/author_icons/shared_first_author-5b0b31b5bdf643b7b35f07956fb5d6e6.svg";